import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-Evacuation-Chair",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Evacuation Chair",
    description: "Evacuation-Chair",
    image: require("./Evacuation-Chair.svg"),
    svgIcon: require("./Evacuation-Chair.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.evacchair-cls1{fill:#da2727;}.evacchair-cls2{fill:#fff;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
            <path
              class="evacchair-cls1"
              d="M0,95.72V0H98.59V95.72ZM32.94,51.54H22a1.85,1.85,0,0,1-.41,0,.77.77,0,0,1-.69-.76c0-.14,0-.27,0-.41V40.27c0-.15,0-.3,0-.45H9.33c-.07.35-.06,46.84,0,47.09h.11L56.94,87h.12l0,0,0,0V75.53c0-.14,0-.28,0-.41s0,0,0,0,0,0-.05,0H45.81a.79.79,0,0,1-.76-.79c0-.13,0-.26,0-.38V63.75c0-.14,0-.29,0-.46H33.73a.82.82,0,0,1-.79-.84V51.54Zm27-23.72c-.17-.83-.33-1.63-.5-2.43a4.23,4.23,0,0,0-.83-1.8,4.38,4.38,0,0,0-6.65,0,3.63,3.63,0,0,0-.8,3.14c.31,1.61.68,3.22,1,4.83l1.08,5L54,40.37a4.06,4.06,0,0,0,.45,1.35,3.48,3.48,0,0,0,3,1.79c.39,0,.79,0,1.18,0H70.6a.4.4,0,0,1,.43.23c.31.56.65,1.1,1,1.65l1,1.7,2.37,4,.91,1.53c.65,1.1,1.28,2.21,1.93,3.3a4.4,4.4,0,0,0,.51.69,2.73,2.73,0,0,0,2.29.82,2.65,2.65,0,0,0,2.07-1.22,2.39,2.39,0,0,0,.1-2.57c-.14-.28-.32-.53-.48-.79-.74-1.25-1.48-2.5-2.23-3.75l-2.17-3.68c-.53-.88-1-1.77-1.57-2.66L76.29,42c-.53-.9-1.08-1.78-1.59-2.69a3.55,3.55,0,0,0-3.24-1.91c-3,0-6.06,0-9.09,0H62l-1.08-5.24H68c.24,0,.49,0,.73,0a2.19,2.19,0,0,0,1.41-.59,2.13,2.13,0,0,0,.14-2.9,2.23,2.23,0,0,0-1.77-.8H59.93ZM52.7,61.37c.83,0,1.65-.08,2.48-.15a17.72,17.72,0,0,0,5.32-1.35,18.23,18.23,0,0,0,5.59-3.56,17.19,17.19,0,0,0,2.63-3.15,14.44,14.44,0,0,0,1.62-3.24A14.08,14.08,0,0,0,71,47.83a1.75,1.75,0,0,0-.17-1.27,2.48,2.48,0,0,0-1.58-1.15,2.23,2.23,0,0,0-2.7,1.67,3.66,3.66,0,0,1-.17.65,13.35,13.35,0,0,1-1.3,2.82c-.34.48-.66,1-1,1.43a12.49,12.49,0,0,1-3.49,3,15.72,15.72,0,0,1-1.87,1,14.27,14.27,0,0,1-14.37-1.91,13,13,0,0,1-3.27-3.75,12,12,0,0,1-1.12-2.64A12.08,12.08,0,0,1,41.26,38a13.14,13.14,0,0,1,3.32-3.7,14.14,14.14,0,0,1,3.32-1.88,8,8,0,0,0,.9-.41,2,2,0,0,0,.14-3.33,2.47,2.47,0,0,0-2.45-.31,19.61,19.61,0,0,0-4.42,2.37A17.51,17.51,0,0,0,36.64,37a17.39,17.39,0,0,0-1.09,2.81A13.11,13.11,0,0,0,35,43a15.32,15.32,0,0,0,.74,6.19,18,18,0,0,0,1.13,2.63A18.9,18.9,0,0,0,39.06,55a18.11,18.11,0,0,0,6.73,4.82A19.53,19.53,0,0,0,52.7,61.37ZM53.52,21a5.31,5.31,0,0,0,4.23-1.7A4.76,4.76,0,0,0,59,16.68a4.86,4.86,0,0,0-1-3.76,5,5,0,0,0-2.34-1.69,5.16,5.16,0,0,0-1.33-.32,5.26,5.26,0,0,0-3.3.75,5.07,5.07,0,0,0-2.33,3.21,4.26,4.26,0,0,0,.14,2.57A5.05,5.05,0,0,0,50,19.36,5.15,5.15,0,0,0,53.52,21Z"
            />
            <path
              class="evacchair-cls2"
              d="M32.94,51.54v10.9a.82.82,0,0,0,.79.84H45c0,.17,0,.32,0,.46V73.87c0,.12,0,.25,0,.38a.79.79,0,0,0,.76.79H57s.05,0,.05,0,0,0,0,0,0,.27,0,.41V86.92l0,0,0,0h-.12L9.46,86.92H9.35c-.08-.25-.09-46.74,0-47.09h11.5c0,.15,0,.3,0,.45V50.35c0,.14,0,.27,0,.41a.77.77,0,0,0,.69.76,1.85,1.85,0,0,0,.41,0h11Z"
            />
            <path
              class="evacchair-cls2"
              d="M59.93,27.82h8.53a2.23,2.23,0,0,1,1.77.8,2.13,2.13,0,0,1-.14,2.9,2.19,2.19,0,0,1-1.41.59c-.24,0-.49,0-.73,0H60.89L62,37.35h.4c3,0,6.06,0,9.09,0a3.55,3.55,0,0,1,3.24,1.91c.51.91,1.06,1.79,1.59,2.69l.45.77c.52.89,1,1.78,1.57,2.66l2.17,3.68c.75,1.25,1.49,2.5,2.23,3.75.16.26.34.51.48.79a2.39,2.39,0,0,1-.1,2.57A2.65,2.65,0,0,1,81,57.39a2.73,2.73,0,0,1-2.29-.82,4.4,4.4,0,0,1-.51-.69c-.65-1.09-1.28-2.2-1.93-3.3l-.91-1.53-2.37-4-1-1.7c-.33-.55-.67-1.09-1-1.65a.4.4,0,0,0-.43-.23H58.67c-.39,0-.79.07-1.18,0a3.48,3.48,0,0,1-3-1.79A4.06,4.06,0,0,1,54,40.37l-.78-3.78-1.08-5c-.35-1.61-.72-3.22-1-4.83a3.63,3.63,0,0,1,.8-3.14,4.38,4.38,0,0,1,6.65,0,4.23,4.23,0,0,1,.83,1.8C59.6,26.19,59.76,27,59.93,27.82Z"
            />
            <path
              class="evacchair-cls2"
              d="M52.7,61.37a19.53,19.53,0,0,1-6.91-1.51A18.11,18.11,0,0,1,39.06,55a18.9,18.9,0,0,1-2.21-3.19,18,18,0,0,1-1.13-2.63A15.32,15.32,0,0,1,35,43a13.11,13.11,0,0,1,.57-3.23A17.39,17.39,0,0,1,36.64,37a17.51,17.51,0,0,1,5.43-6.3,19.61,19.61,0,0,1,4.42-2.37,2.47,2.47,0,0,1,2.45.31A2,2,0,0,1,48.8,32a8,8,0,0,1-.9.41,14.14,14.14,0,0,0-3.32,1.88A13.14,13.14,0,0,0,41.26,38a12.1,12.1,0,0,0-.2,12.36,13,13,0,0,0,3.27,3.75,14.24,14.24,0,0,0,5.37,2.62,14.4,14.4,0,0,0,9-.71,15.72,15.72,0,0,0,1.87-1,12.49,12.49,0,0,0,3.49-3c.36-.46.68-.95,1-1.43a13.35,13.35,0,0,0,1.3-2.82,3.66,3.66,0,0,0,.17-.65,2.23,2.23,0,0,1,2.7-1.67,2.48,2.48,0,0,1,1.58,1.15A1.75,1.75,0,0,1,71,47.83a14.08,14.08,0,0,1-.66,2.09,14.44,14.44,0,0,1-1.62,3.24,17.19,17.19,0,0,1-2.63,3.15,18.23,18.23,0,0,1-5.59,3.56,17.72,17.72,0,0,1-5.32,1.35C54.35,61.29,53.53,61.32,52.7,61.37Z"
            />
            <path
              class="evacchair-cls2"
              d="M53.52,21A5.15,5.15,0,0,1,50,19.36a5.05,5.05,0,0,1-1.16-1.92,4.26,4.26,0,0,1-.14-2.57,5.07,5.07,0,0,1,2.33-3.21,5.26,5.26,0,0,1,3.3-.75,5.16,5.16,0,0,1,1.33.32A5,5,0,0,1,58,12.92a4.86,4.86,0,0,1,1,3.76,4.76,4.76,0,0,1-1.24,2.6A5.31,5.31,0,0,1,53.52,21Z"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
